export default "__VITE_ASSET__DF9O_uOw__"